import { FC } from 'react';

const IconChatOffline: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4.38569V20L2.83091 18.097C3.77909 17.46 4.95909 17.1093 6.15455 17.1093H9L11 15.1093H6.15455C4.69485 15.1093 3.23629 15.504 2 16.2551V4.38569C2 4.37618 2.00013 4.30679 2.11657 4.20494C2.23655 4.09999 2.44727 4 2.72727 4H18V10L20 8V2H2.72727C1.22364 2 0 3.07038 0 4.38569Z"
      fill="currentColor"
    />
    <path
      d="M19.9953 12.4142L18.5811 11L15.7527 13.8284L12.9242 11L11.51 12.4142L14.3384 15.2426L11.51 18.0711L12.9242 19.4853L15.7527 16.6569L18.5811 19.4853L19.9953 18.0711L17.1669 15.2426L19.9953 12.4142Z"
      fill="currentColor"
    />
  </svg>
);

export { IconChatOffline };
